import {ChangeEvent, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectClinicData,
  setClinicData,
} from '@/src/app/store/clinic/clinicDataSlice';
import ClinicVerificationDocumentStatusesLayout from '@/src/profile/accountSettings/components/ClinicVerificationDocumentStatusesLayout';
import requestUpdateClinicDocument from '@/src/profile/accountSettings/utils/requestUploadClinicDocument';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import PageTitle from '../../../ui/pageTitle/components/PageTitle';
import css from '../styles/ClinicVerificationDocument.module.css';

const ClinicVerificationDocument = () => {
  const {clinicData} = useSelector(selectClinicData);
  const dispatch = useDispatch();

  const handleUploadNewDocument = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;

      if (!files.length) {
        return;
      }

      const {status, responseBody} = await requestUpdateClinicDocument(
        clinicData.id,
        files[0]
      );

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(
          setClinicData({
            clinicData: responseBody,
            isFetched: true,
          })
        );
      }
    },
    [clinicData.id]
  );

  return (
    <div>
      <PageTitle
        tag={PageTitle.TAG.H3}
        title={<TextLocal id={'profile.clinic-verification'} />}
        offset={PageTitle.BOTTOM_OFFSET.OFFSET_15}
      />
      <div className={css.content}>
        <Text>
          <TextLocal id={'profile.official-company-certificate'} />
        </Text>
        <div>
          <ClinicVerificationDocumentStatusesLayout
            status={clinicData.status}
            onUploadNewDocumentClick={handleUploadNewDocument}
          />
        </div>
      </div>
    </div>
  );
};

export default ClinicVerificationDocument;
